import React from 'react';
import { Button, ButtonProps } from '@mui/material';

type Props = ButtonProps;

export function NotificationActionButton({ children, sx, ...buttonProps }: Props) {
  return (
    <Button
      {...buttonProps}
      size="small"
      variant="outlined"
      sx={[{ marginLeft: 2 }, ...(Array.isArray(sx) ? sx : [sx])]}
    >
      {children}
    </Button>
  );
}
